module.exports = __webpack_public_path__ + "img/Carousel-Beneficios-icono-08.69ea1675.svg";